export const TASK_STATE_TODO = "todo";
export const TASK_STATE_DONE = "done";
